import { ApplicationError } from "@rocicorp/zero";

export type ZeroDefinitionNotFoundDetails = {
  kind: "ZeroDefinitionNotFound";
  definition: "query" | "mutator";
  name: string;
};

export function zeroDefinitionNotFoundMessage(
  definition: ZeroDefinitionNotFoundDetails["definition"],
  name: string
): string {
  const label = definition === "query" ? "Query" : "Mutator";
  return `${label} not found: ${name}`;
}

export function zeroDefinitionNotFoundError(
  definition: ZeroDefinitionNotFoundDetails["definition"],
  name: string
): ApplicationError<ZeroDefinitionNotFoundDetails> {
  return new ApplicationError(zeroDefinitionNotFoundMessage(definition, name), {
    details: { kind: "ZeroDefinitionNotFound", definition, name },
  });
}

export function zeroDefinitionNotFoundDetails(
  error: unknown
): ZeroDefinitionNotFoundDetails | undefined {
  const details = (error as { details?: ZeroDefinitionNotFoundDetails } | null)
    ?.details;
  return details?.kind === "ZeroDefinitionNotFound" ? details : undefined;
}
